export enum AttendanceType {
  InPerson = 'IN_PERSON',
  Online = 'ONLINE',
}

export enum CourseEnrolmentState {
  Active = 'ACTIVE',
  OnTrial = 'ON_TRIAL',
  Unenrolled = 'UNENROLLED',
}

export enum DiscountType {
  Percentage = 'PERCENTAGE',
  Constant = 'CONSTANT',
  OneOff = 'ONEOFF',
}

export enum ContactOption {
  Student = 'STUDENT',
  Parent = 'PARENT',
  Both = 'BOTH',
  None = 'NONE',
}

export enum StudentState {
  // Converted from a lead or left without any classes - we want them to re-enrol in a course
  Lead = 'LEAD',
  // Enrolled at the centre, but not yet added to any classes
  Enrolled = 'ENROLLED',
  // Added to classes, but waiting for them to attend their first lesson
  PendingAttendance = 'PENDING_ATTENDANCE',
  // They have started attending classes, but none of their courses are in an ACTIVE state
  OnTrial = 'ON_TRIAL',
  // In an Active state for at least ONE of the courses
  Active = 'ACTIVE',
  // No longer in our target demographic due to age
  Graduated = 'GRADUATED',
  // Duplicate entries / error entries that should be ignored completely
  Archived = 'ARCHIVED',
}
